import React, { createContext, useContext, useEffect, useState } from "react";
import { DataEncoder } from "../utils/common";

const CategoriesContext = createContext({ data: null, loading: true, error: null });
export const useCategories = () => useContext(CategoriesContext);

export function CategoriesProvider({ children }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [state, setState] = useState({ data: null, loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    const encoder = new DataEncoder();
    const params = { with: ["categories.categories.categories"], filters: { level: 1 } };

    fetch(`${API_BASE_URL}/categories?${encoder.encode(params)}`)
      .then(r => r.ok ? r.json() : Promise.reject(new Error("Error al cargar categorías")))
      .then(data => { if (!cancelled) setState({ data, loading: false, error: null }); })
      .catch(error => { if (!cancelled) setState({ data: null, loading: false, error }); });

    return () => { cancelled = true; };
  }, []);

  return <CategoriesContext.Provider value={state}>{children}</CategoriesContext.Provider>;
}
